import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["ressources"])
  },
  methods: {
    getRessource(code) {
      let found = this.ressources.find((r) => r.code == code)
      if (found) {
        return found.valeur
      }
      return `[${code}]`
    }
  }
}